import { connect } from 'react-redux';
import HeaderText from 'header/components/title';
import { withRouter } from 'react-router';

export function mapStateToProps({ profile }, { location }) {
  const { username } = profile.view.data ? profile.view.data : { username: '' };
  let title = `${username}'s Profile`;

  if (location.pathname.match(/portfolio/)) {
    title = `${username}'s Portfolio`;
  } else if (location.pathname.match(/your-entries/)) {
    title = "Your entries";
  }

  return {
    title,
    isTitleMain: true
  };
}

export default withRouter(connect(mapStateToProps)(HeaderText));



// WEBPACK FOOTER //
// ./profile/containers/header_title.js